import {
    CREATE_GENERAL_PO_INWARD_DETAILS_REQUEST,
    CREATE_GENERAL_PO_INWARD_DETAILS_SUCCESS,
    CREATE_GENERAL_PO_INWARD_DETAILS_FAILURE,
    DELETE_GENERAL_PO_INWARD_DETAILS_REQUEST,
    DELETE_GENERAL_PO_INWARD_DETAILS_SUCCESS,
    DELETE_GENERAL_PO_INWARD_DETAILS_FAILURE,
    FETCH_SINGLE_GENERAL_PO_INWARD_DETAILS_REQUEST,
    FETCH_SINGLE_GENERAL_PO_INWARD_DETAILS_SUCCESS,
    FETCH_SINGLE_GENERAL_PO_INWARD_DETAILS_FAILURE,
    FETCH_GENERAL_PO_INWARD_DETAILS_REQUEST,
    FETCH_GENERAL_PO_INWARD_DETAILS_SUCCESS,
    FETCH_GENERAL_PO_INWARD_DETAILS_FAILURE,
    UPDATE_GENERAL_PO_INWARD_DETAILS_REQUEST,
    UPDATE_GENERAL_PO_INWARD_DETAILS_SUCCESS,
    UPDATE_GENERAL_PO_INWARD_DETAILS_FAILURE,
    RESET_GENERAL_PO_INWARD_DETAILS_INFO,
    CREATE_GENERAL_PO_INWARD_DETAILS_FORM,
    UPDATE_GENERAL_PO_INWARD_DETAILS_FORM,
    FETCH_GENERAL_PO_INWARD_DETAILS_WITHOUT_ID_SUCCESS,
    FETCH_PREVIOUS_GENERAL_PO_INWARD_DETAILS_FAILURE,
    FETCH_PREVIOUS_GENERAL_PO_INWARD_DETAILS_REQUEST,
    FETCH_PREVIOUS_GENERAL_PO_INWARD_DETAILS_SUCCESS,
    CREATE_GENERAL_PO_INWARD_DETAILS_GET_SUCCESS,
    GENERAL_PO_INWARD_DETAILS_PO_DETAILS_DISABLED

} from './generalPoInwardDetails.actionsType';

export const GENERAL_PO_INWARD_DETAILS = 'generalPoInwardDetails';

let initialState = {
    loading: false,
    generalPoInwardDetails: [],
    generalPoInwardDetailsWithoutId: [],
    generalPoInwardDetailsForm: {},
    selectedState: {},
    errorMessage: '',
    previousGetList: [],
    isPoDetailsDisabled: false


};

export let generalPoInwardDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_GENERAL_PO_INWARD_DETAILS_REQUEST:
        case CREATE_GENERAL_PO_INWARD_DETAILS_REQUEST:
        case UPDATE_GENERAL_PO_INWARD_DETAILS_REQUEST:
        case FETCH_SINGLE_GENERAL_PO_INWARD_DETAILS_REQUEST:
        case DELETE_GENERAL_PO_INWARD_DETAILS_REQUEST:
        case FETCH_PREVIOUS_GENERAL_PO_INWARD_DETAILS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_GENERAL_PO_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                generalPoInwardDetails: updatePayload
            };
        case FETCH_GENERAL_PO_INWARD_DETAILS_WITHOUT_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                generalPoInwardDetailsWithoutId: updatePayload
            };
        case CREATE_GENERAL_PO_INWARD_DETAILS_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                inwardGetDetailList: updatePayload
            }
        case CREATE_GENERAL_PO_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                generalPoInwardDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0
                },
                isPoDetailsDisabled: false
            };
        case UPDATE_GENERAL_PO_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                generalPoInwardDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0
                },
                isPoDetailsDisabled: false

            };
        case FETCH_SINGLE_GENERAL_PO_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                generalPoInwardDetailsForm: updatePayload
            };
        case DELETE_GENERAL_PO_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                generalPoInwardDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0
                },
                isPoDetailsDisabled: false

            };
        case RESET_GENERAL_PO_INWARD_DETAILS_INFO:
            return {
                ...state,
                previousGetList: [],
                generalPoInwardDetailsForm:
                {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0
                },
            };
        case FETCH_PREVIOUS_GENERAL_PO_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                previousGetList: updatePayload
            };
        case CREATE_GENERAL_PO_INWARD_DETAILS_FORM:
        case UPDATE_GENERAL_PO_INWARD_DETAILS_FORM:
            return {
                ...state,
                loading: false,
                generalPoInwardDetailsForm: {
                    ...state.generalPoInwardDetailsForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_GENERAL_PO_INWARD_DETAILS_FAILURE:
        case CREATE_GENERAL_PO_INWARD_DETAILS_FAILURE:
        case UPDATE_GENERAL_PO_INWARD_DETAILS_FAILURE:
        case FETCH_SINGLE_GENERAL_PO_INWARD_DETAILS_FAILURE:
        case DELETE_GENERAL_PO_INWARD_DETAILS_FAILURE:
        case FETCH_PREVIOUS_GENERAL_PO_INWARD_DETAILS_FAILURE:
            return {
                ...state,
                loading: false
            };
        case GENERAL_PO_INWARD_DETAILS_PO_DETAILS_DISABLED:
            return {
                ...state,
                isPoDetailsDisabled: payload
            };
        default:
            return state;
    }
};
